import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { liveObject } from '../../core/i18n';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-success-lead',
  templateUrl: './success-lead.component.html',
  styleUrl: './success-lead.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SuccessLeadComponent implements OnInit {
  protected list: any = [];

  constructor(private readonly translate: TranslateService) {}

  ngOnInit(): void {
    // liveObject: посилання стабільне, але заголовки перечитуються
    // після зміни мови — без нього вони застигали на момент відкриття модалки
    this.list = liveObject(() => [
      {
        key: 'deal',
        title: this.translate.instant('it_deal'),
      },
      // {
      //   key: 'contact',
      //   title: this.translate.instant('contact'),
      // },
      // {
      //   key: 'deal_and_contact',
      //   title: this.translate.instant('it_deal') + ' + ' + this.translate.instant('contact'),
      // },
    ]);
  }
}
